<template>
  <BusinessCrud
    title="积分产品"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getPointsGiftList"
    :save-api="savePointsGift"
    :delete-api="deletePointsGift"
    :defaults="{ giftCategory: '优惠券', couponId: null, coverImage: '', pointsPrice: 0, stock: 0, limitQuantity: 1, sortOrder: 0, status: 1 }"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getPointsGiftList, savePointsGift, deletePointsGift, getPointsCouponOptions } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    return {
      getPointsGiftList,
      savePointsGift,
      deletePointsGift,
      searchFields: [
        { key: 'name', label: '礼品名称' },
        { key: 'giftCategory', label: '分类', type: 'select', options: [{ label: '优惠券', value: '优惠券' }, { label: '实物', value: '实物' }, { label: '虚拟', value: '虚拟' }] },
        { key: 'status', label: '状态', type: 'select', options: [{ label: '未关联', value: -1 }, { label: '上架', value: 1 }, { label: '下架', value: 0 }] }
      ],
      columns: [
        { title: '礼品名称', dataIndex: 'name' },
        { title: '分类', dataIndex: 'giftCategory' },
        { title: '积分价格', dataIndex: 'pointsPrice' },
        { title: '限购数量', dataIndex: 'limitQuantity' },
        { title: '库存', dataIndex: 'stock' },
        { title: '排序', dataIndex: 'sortOrder' },
        { title: '状态', dataIndex: 'status', customRender: (value, record) => record.giftCategory !== '实物' && !record.couponId ? '未关联' : (value === 1 ? '上架' : '下架') }
      ],
      formFields: [
        { key: 'giftCategory', label: '分类', type: 'select', options: [{ label: '优惠券', value: '优惠券' }, { label: '实物', value: '实物' }, { label: '虚拟', value: '虚拟' }] },
        { key: 'couponId', label: '关联优惠券', type: 'select', options: [], visible: form => form.giftCategory !== '实物' },
        { key: 'name', label: '标题' },
        { key: 'coverImage', label: '图片', type: 'upload-image' },
        { key: 'pointsPrice', label: '所需积分', type: 'number', min: 1, precision: 0 },
        { key: 'limitQuantity', label: '限购数量', type: 'number', min: 1, precision: 0 },
        { key: 'stock', label: '库存', type: 'number', min: 0, precision: 0 },
        { key: 'description', label: '简短说明', type: 'textarea' },
        { key: 'detailHtml', label: '商品详情富文本', type: 'richtext' },
        { key: 'sortOrder', label: '排序', type: 'number', min: 0, precision: 0 },
        { key: 'status', label: '状态', type: 'switch' }
      ]
    }
  },
  created() {
    getPointsCouponOptions().then(res => {
      this.formFields.find(field => field.key === 'couponId').options = (res.data || []).map(coupon => ({ label: `${coupon.name}（满${coupon.thresholdAmount || 0}减${coupon.discountAmount || 0}）`, value: coupon.id }))
    }).catch(error => { this.$message.error(error.message || '优惠券选项加载失败') })
  }
}
</script>
